import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  TextField,
} from '@mui/material';
import { post } from 'api';
import { enqueueSnackbar } from 'notistack';
import * as yup from 'yup';

const vendorSchema = yup.object({
  vendorName: yup.string().required('Vendor Name is mandatory'),
  vendorCompanyName: yup.string().required('Vendor Company Name is mandatory'),
  gst: yup.string().required('GST is mandatory'),
  address: yup.string().required('Address is mandatory'),
  email: yup.string().optional(),
  mobile: yup.string().optional(),
});

export default function VendorCreate({ open, onClose }) {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(vendorSchema),
    defaultValues: {
      vendorName: '',
      vendorCompanyName: '',
      gst: '',
      address: '',
      email: '',
      mobile: '',
    },
  });

  const submitStock = async (data) => {
    try {
      const res = await post('users/create_vendor', data);

      if (res.status == 200) {
        enqueueSnackbar(res.message || 'Stock Update Successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      } else {
        enqueueSnackbar(res.message || 'Error While Updateing Stock Try Again Latter', {
          variant: 'error',
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error While Updateing Stock Try Again Latter', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    } finally {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      component="form"
      onSubmit={handleSubmit(submitStock)}
    >
      {/* HEADER */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: 1 }}>
        <DialogTitle sx={{ fontSize: 20, fontWeight: 700 }}>Create Vendor</DialogTitle>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Stack>

      {/* BODY */}
      <DialogContent sx={{ px: 2 }}>
        {/* VENDOR */}
        <Grid container spacing={2}>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <Controller
              control={control}
              name="vendorName"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Vendor Name"
                  error={!!errors.vendorName}
                  helperText={errors.vendorName?.message}
                  slotProps={{ htmlInput: { maxLength: 30 } }}
                />
              )}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <Controller
              control={control}
              name="vendorCompanyName"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Vendor Company Name"
                  error={!!errors.vendorCompanyName}
                  helperText={errors.vendorCompanyName?.message}
                  slotProps={{ htmlInput: { maxLength: 30 } }}
                />
              )}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <Controller
              control={control}
              name="gst"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Enter GST Number"
                  error={!!errors.gst}
                  helperText={errors.gst?.message}
                  slotProps={{ htmlInput: { maxLength: 15 } }}
                />
              )}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <Controller
              control={control}
              name="email"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Email(Optional)"
                  error={!!errors.email}
                  helperText={errors.email?.message}
                />
              )}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6 }}>
            <Controller
              control={control}
              name="mobile"
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Mobile(Optional)"
                  error={!!errors.mobile}
                  helperText={errors.mobile?.message}
                />
              )}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 12 }}>
            <Controller
              control={control}
              name="address"
              render={({ field }) => (
                <TextField
                  {...field}
                  multiline
                  rows={3}
                  fullWidth
                  label="Address"
                  error={!!errors.address}
                  helperText={errors.address?.message}
                  slotProps={{ htmlInput: { maxLength: 200 } }}
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>

      {/* FOOTER */}
      <DialogActions sx={{ p: 2 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" type="submit">
          Creat
        </Button>
      </DialogActions>
    </Dialog>
  );
}
